import { render } from "./FooterComponent.vue?vue&type=template&id=3ce145e3&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=3ce145e3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Documents\\GitHub\\rubanero14-Convert-XML-to-JSON-Guide\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce145e3"]])

export default __exports__